import * as React from 'react';
import { useSelector } from 'react-redux';
import { ErrorMessageBanner } from '../../../components/ErrorMessage';
import { useAppDispatch } from '../../../hooks';
import { deleteErrorMessage } from '../../../slices';
import { selectEstimationTarget, selectErrorMessage } from '../../../selectors';

export const ErrorMessageContainer: React.FC = () => {
  const dispatch = useAppDispatch();

  const errorMessage = useSelector(selectErrorMessage);
  const estimationTarget = useSelector(selectEstimationTarget);

  React.useEffect(() => {
    // При смене типа недвижимости убираем сообщение об ошибке
    dispatch(deleteErrorMessage());
  }, [dispatch, estimationTarget]);

  if (!errorMessage) {
    return null;
  }

  return <ErrorMessageBanner title={errorMessage} />;
};
